/**
 * Data layer for the COMPANY panel's Sleep section.
 * Same page-facing shapes as container/SleepHub/sleepHubApi.js, but backed by
 * the company/v1 sleep-hub endpoints (token-scoped to the company; the
 * B2B/Members toggle is appended by api/companyApi.js on every call).
 */

import {
  getCompanySleepTrackerDashboard,
  getCompanySleepSoundsDashboard,
  getCompanySleepUsers,
  getCompanySleepUserDetail
} from '../../../../api/companyApi';
import { unwrap, adaptTracker, adaptSoundsListening } from '../../../SleepHub/sleepHubApi';

export const fetchCompanyTrackerDashboard = async () => {
  try {
    const data = unwrap(await getCompanySleepTrackerDashboard());
    return {
      ...adaptTracker(data),
      // Company-only: the size of the population, so the page can say
      // "96 of 240 employees track sleep".
      totalUsers: data.totalUsers
    };
  } catch (error) {
    console.error('fetchCompanyTrackerDashboard error:', error);
    return null;
  }
};

export const fetchCompanySoundsDashboard = async () => {
  try {
    const data = unwrap(await getCompanySleepSoundsDashboard());
    return {
      ...adaptSoundsListening(data),
      totalUsers: data.totalUsers
    };
  } catch (error) {
    console.error('fetchCompanySoundsDashboard error:', error);
    return null;
  }
};

// Matches the SleepUsersTable fetcher contract ({page, perPage, search}).
export const fetchCompanySleepUsers = async ({ page = 1, perPage = 10, search = '' } = {}) => {
  const data = unwrap(await getCompanySleepUsers(page, perPage, search));
  return { data: data.data || [], totalCount: data.totalCount || 0 };
};

export const fetchCompanySleepUserDetail = async (userId) => {
  try {
    return unwrap(await getCompanySleepUserDetail(userId));
  } catch (error) {
    console.error('fetchCompanySleepUserDetail error:', error);
    return null;
  }
};
